import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { getLevelAmount } from "../../config/autoFillProgramConfig";
import {
  buildLevelForfeitureFirestorePatch,
  getLevelForfeitureState,
  initialLevelForfeitureState,
} from "./autoFillLevelForfeiturePure";

export {
  initialLevelForfeitureState,
  getLevelForfeitureState,
  buildLevelForfeitureFirestorePatch,
  sumPointsCreditedFromLedgerRows,
  hydrateLevelForfeitureStates,
  mergeLevelForfeiturePersistUpdates,
  allocateWithdrawalAcrossLevelStates,
  allocateWithdrawalAtSingleLevel,
} from "./autoFillLevelForfeiturePure";

export async function applyWithdrawalLevelForfeitureUpdates(
  programDocId,
  program,
  levelUpdates
) {
  if (!programDocId || !levelUpdates || Object.keys(levelUpdates).length === 0) {
    return;
  }
  let patch = { updatedAt: new Date().toISOString() };
  const mergedProgram = { ...program };
  Object.entries(levelUpdates).forEach(([level, state]) => {
    const partial = buildLevelForfeitureFirestorePatch(mergedProgram, level, state);
    patch = {
      ...patch,
      levelForfeiture: partial.levelForfeiture,
      ...(partial.level6 ? { level6: partial.level6 } : {}),
    };
    mergedProgram.levelForfeiture = partial.levelForfeiture;
    if (partial.level6) mergedProgram.level6 = partial.level6;
  });
  await updateDoc(doc(db, "autoFillPrograms", programDocId), patch);
}

export async function recordLevelPointsCredited(
  programDocId,
  program,
  level,
  creditAmount
) {
  const L = Number(level);
  const levelAmount = getLevelAmount(L);
  const existing = getLevelForfeitureState(program, L);
  const base = existing || initialLevelForfeitureState(new Date().toISOString());
  const nextCredited = Math.min(
    levelAmount,
    (Number(base.pointsCredited) || 0) + Number(creditAmount)
  );
  const nextState = {
    ...base,
    reachedAt: base.reachedAt || new Date().toISOString(),
    pointsCredited: nextCredited,
  };
  await updateDoc(
    doc(db, "autoFillPrograms", programDocId),
    buildLevelForfeitureFirestorePatch(program, L, nextState)
  );
}
